import React from 'react';
import {Grid, Box} from '@mui/material';
import {PlatformDrivers} from './PlatformDrivers';
import SvgControl4Logo from './svg/SvgControl4Logo';
import SvgRtiLogo from './svg/SvgRtiLogo';
import SvgElanLogo from './svg/SvgElanLogo';
import shadow from '../assets/shadow.png';

const bottomPadding = 4;
export const PortfolioPanel = () => {
	return (
		<Box sx={{width: '100%'}}>
			<div id={'portfolioPanel'}/>
			<Box sx={{
				// On md+ the cards sit in one row, half on white, half on grey.
				// Stacked on mobile the 50/50 split would cut through a card,
				// so there the panel stays white.
				background: {
					xs: '#ffffff',
					md: 'linear-gradient(to bottom, white 0%, white 50%, #E0E5E7FF 50%, #E0E5E7FF 100%)',
				},
				width: '100%',
			}}>
				<Grid container paddingTop={3} sx={{display: 'flex', justifyContent: 'center'}} columnSpacing={2}>
					<Grid item xs={12} md={'auto'} sx={{display: 'flex', justifyContent: 'center'}}
					      paddingBottom={{xs: 1.5, md: bottomPadding}}>
						<PlatformDrivers Logo={SvgControl4Logo} text={'Your Home. Simplified.'} platform={'control4'}/>
					</Grid>
					<Grid item xs={12} md={'auto'} sx={{display: 'flex', justifyContent: 'center'}}
					      paddingBottom={{xs: 1.5, md: bottomPadding}}>
						<PlatformDrivers Logo={SvgRtiLogo} text={'Elegant, intuitive, easy...'} platform={'rti'}/>
					</Grid>
					<Grid item xs={12} md={'auto'} sx={{display: 'flex', justifyContent: 'center'}}
					      paddingBottom={{xs: 1.5, md: bottomPadding}}>
						<PlatformDrivers Logo={SvgElanLogo} text={'One Home. One Solution.'} platform={'elan'}/>
					</Grid>
				</Grid>
			</Box>
			<img
				src={shadow}
				alt="Shadow"
				style={{width: "100%", display: 'block'}}
			/>
		</Box>
	);
};
